import React, { useEffect } from 'react';
import { CheckCircle, XCircle, X, AlertCircle } from 'lucide-react';
import { Button } from './button';

/**
 * Componente de notificación toast
 * Muestra mensajes de éxito, error y advertencia
 */
const Toast = ({ 
  message, 
  type = 'success', // 'success', 'error', 'warning'
  isVisible = false, 
  onClose, 
  duration = 3000 
}) => {
  // Auto-cerrar después del tiempo especificado
  useEffect(() => {
    if (isVisible && duration > 0) {
      const timer = setTimeout(() => {
        onClose();
      }, duration);

      return () => clearTimeout(timer);
    }
  }, [isVisible, duration, onClose]);

  if (!isVisible) return null;

  // Configuración por tipo
  const config = {
    success: {
      icon: <CheckCircle className="w-5 h-5" />,
      bgColor: 'bg-green-50',
      borderColor: 'border-green-200',
      textColor: 'text-green-800',
      iconColor: 'text-green-600'
    },
    error: {
      icon: <XCircle className="w-5 h-5" />,
      bgColor: 'bg-red-50',
      borderColor: 'border-red-200',
      textColor: 'text-red-800',
      iconColor: 'text-red-600'
    },
    warning: {
      icon: <AlertCircle className="w-5 h-5" />,
      bgColor: 'bg-yellow-50',
      borderColor: 'border-yellow-200',
      textColor: 'text-yellow-800',
      iconColor: 'text-yellow-600'
    },
    info: {
      icon: <AlertCircle className="w-5 h-5" />,
      bgColor: 'bg-blue-50',
      borderColor: 'border-blue-200',
      textColor: 'text-blue-800',
      iconColor: 'text-blue-600'
    }
  };

  const currentConfig = config[type];

  return (
    <div className="fixed top-4 right-4 z-50 animate-in slide-in-from-top-2">
      <div className={`
        flex items-center gap-3 p-4 rounded-lg border shadow-lg
        ${currentConfig.bgColor} ${currentConfig.borderColor}
        max-w-sm
      `}>
        <div className={currentConfig.iconColor}>
          {currentConfig.icon}
        </div>
        
        <div className={`flex-1 text-sm font-medium ${currentConfig.textColor}`}>
          {message}
        </div>
        
        <Button
          onClick={onClose}
          variant="ghost"
          size="icon"
          className={`p-1 rounded-full hover:bg-opacity-20 ${currentConfig.textColor} hover:bg-black`}
        >
          <X className="w-4 h-4" />
        </Button>
      </div>
    </div>
  );
};

export default Toast; 